<div class="card-body">
    <div id="apex-monochrome-pie-chart"></div>
</div>